import { render, staticRenderFns } from "./IconCarousel.vue?vue&type=template&id=bd351a0e&scoped=true"
import script from "./IconCarousel.vue?vue&type=script&lang=js"
export * from "./IconCarousel.vue?vue&type=script&lang=js"
import style0 from "./IconCarousel.vue?vue&type=style&index=0&id=bd351a0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd351a0e",
  null
  
)

export default component.exports